<template>
    <b-col sm="6" lg="3">
        <b-card class="bg-primary" style="border: none; border-radius: 8px; box-shadow: 0px 10px 20px rgba(0, 0, 0, .18) !important;"
                body-class="cardBody">
            <div class="mt-3 mb-0 mx-3">
                <h4>{{ device.name }}</h4>
                <p>{{ deviceStatus }}</p>
            </div>

            <div style="height: 4.8rem;"></div>

            <div class="mb-1 mx-1">
                <b-btn class="w-25 device-button" variant="primary" @click="viewVirtualDevice()">
                    <i class="icon-magnifier"></i>
                </b-btn>

                <b-btn class="w-25 device-button" variant="primary" @click="editVirtualDevice()">
                    <i class="icon-wrench"></i>
                </b-btn>

                <b-btn v-if="!device.mac_address && device.privilege_level === 3"
                       class="w-25 device-button" variant="primary" @click="linkVirtualDevice()">
                    <i class="icon-globe"></i>
                </b-btn>

                <b-btn v-if="device.mac_address && device.privilege_level === 3"
                       class="w-25 device-button" variant="primary" @click="unlinkVirtualDevice()">
                    <i class="icon-logout"></i>
                </b-btn>

                <b-btn v-if="device.privilege_level === 3"
                       class="w-25 device-button" variant="primary" @click="deleteVirtualDevice()">
                    <i class="icon-trash"></i>
                </b-btn>
            </div>
        </b-card>
    </b-col>
</template>

<script>
    export default {
        name: "VirtualDeviceItem",

        props: [
            'device'
        ],

        computed: {
            deviceStatus: function () {
                let macAddress = this.device.mac_address;

                if (macAddress) {
                    return macAddress;
                } else {
                    if (this.device.unlinked) {
                        return 'Unlinked';
                    } else {
                        return 'Empty';
                    }
                }
            }
        },

        methods: {
            viewVirtualDevice() {
                this.$router.push({name: 'device', params: {id: this.device.id}}, () => {
                    //on complete
                }, () => {
                    //on abort
                    this.$Progress.fail();
                    this.$root.$emit('showInfo', "There is no data available for display.");
                    this.$root.$emit('bv::show::modal', 'info-modal');
                });
            },

            editVirtualDevice() {
                this.$router.push({name: 'edit-device', params: {id: this.device.id}}, () => {
                    //on complete
                }, () => {
                    //on abort
                    this.$Progress.fail();
                    this.$root.$emit('showInfo', "Link a device to be able to edit it.");
                    this.$root.$emit('bv::show::modal', 'info-modal');
                });
            },

            deleteVirtualDevice() {
                this.$root.$emit('device-to-delete-id', this.device.id);
                this.$root.$emit('bv::show::modal', 'deleteDeviceModal');
            },

            linkVirtualDevice() {
                this.$root.$emit('device-to-link-id', this.device.id);
                if (this.$platform === 'web') {
                    this.$root.$emit('bv::show::modal', 'LinkByPasscodeModal');
                } else {
                    this.$root.$emit('bv::show::modal', 'linkingOptionsModal');
                }
            },

            unlinkVirtualDevice() {
                this.$root.$emit('device-to-unlink-id', this.device.id);
                this.$root.$emit('bv::show::modal', 'unlinkDeviceModal');
            }
        }
    }
</script>

<style scoped>
    .cardBody {
        padding: 0;
    }

    .device-button:focus {
        box-shadow: none;
    }
</style>
